import "./text-image.scss";
